import Skeleton from "@mui/material/Skeleton";

const DashboardSkeleton = () => {
  return (
    <>
      <div>
        <h4 className="subheading">
          {" "}
          <Skeleton variant="text" className="dsh_skl_title" />
        </h4>
        <div className="dashboard_top_box">
          <div className="row g-4 mx-0 dashboard_top_row">
            <div className="col-xl-5">
              <div className="dashboard_box_left">
                <div className="dashboard_box_flx">
                  <div className="dashboard_box">
                    <Skeleton variant="text" className="dsh_bx_icon" />
                    <span>
                      <Skeleton variant="text" className="dsh_bx_title" />
                    </span>
                    <h4>
                      <Skeleton variant="text" className="dsh_bx_title" />
                    </h4>
                    {/* <small>Wallet Balance</small> */}
                  </div>
                  <div className="dashboard_box">
                    <Skeleton variant="text" className="dsh_bx_icon" />
                    <span>
                      <Skeleton variant="text" className="dsh_bx_title" />
                    </span>
                    <h4>
                      <Skeleton variant="text" className="dsh_bx_title" />
                    </h4>
                    {/* <small>Wallet Balance</small> */}
                  </div>
                </div>
                <div className="dashboard_box_flx dsh_bx_mt">
                  <div className="dashboard_box">
                    <Skeleton variant="text" className="dsh_bx_icon" />
                    <span>
                      <Skeleton variant="text" className="dsh_bx_title" />
                    </span>
                    <h4>
                      <Skeleton variant="text" className="dsh_bx_title" />
                    </h4>
                    {/* <small>Wallet Balance</small> */}
                  </div>
                  <div className="dashboard_box">
                    <Skeleton variant="text" className="dsh_bx_icon" />
                    <span>
                      <Skeleton variant="text" className="dsh_bx_title" />
                    </span>
                    <h4>
                      <Skeleton variant="text" className="dsh_bx_title" />
                    </h4>
                    {/* <small>Wallet Balance</small> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-7 chart_main_col">
              <div className="h-100">
                <Skeleton variant="rectangular" className="dsh_skl_chart" />
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard_btm">
          <div className="dsh_subtitle_header">
            <h4 className="dsh_subtitle">
              <Skeleton variant="text" className="dsh_skl_title" />
            </h4>
          </div>

          <div className="dsh_inv_grid mt-4">
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="dsh_inv_card">
                <div className="dsh_inv_head">
                  <div className="dsh_inv_top">
                    <Skeleton variant="text" className="dsh_skl_card_title" />
                  </div>
                  <Skeleton
                    variant="rectangular"
                    className="dsh_skl_card_img"
                  />
                  <Skeleton variant="text" className="dsh_skl_card_subtitle" />
                  <Skeleton variant="text" className="dsh_skl_card_subcnt" />
                  <div className="mt-3">
                    <div className="dsh_inv_cd_flx">
                      <div className="dsh_inv_cd_lft">
                        <span>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl"
                          />
                        </span>
                        <h4>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl_cnt"
                          />
                        </h4>
                      </div>
                      <div className="dsh_inv_cd_lft">
                        <span>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl"
                          />
                        </span>
                        <h4>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl_cnt"
                          />
                        </h4>
                      </div>
                    </div>
                    <div className="dsh_inv_cd_flx mt-3">
                      <div className="dsh_inv_cd_lft">
                        <span>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl"
                          />
                        </span>
                        <h4>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl_cnt"
                          />
                        </h4>
                      </div>
                      <div className="dsh_inv_cd_lft">
                        <span>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl"
                          />
                        </span>
                        <h4>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl_cnt"
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <Skeleton variant="text" className="dsh_skl_card_btn" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardSkeleton;
